import React from 'react';
import {
    StyledBody,
    StyledCol,
    StyledHead,
    StyledHeadCell, StyledResponsiveContainer,
    StyledRow,
    StyledTable
} from 'src/ui/common/molecules/table/table.styles';


export const HeadCell = ({ children, ...rest }: React.ComponentPropsWithoutRef<'th'>) => (
    <StyledHeadCell {...rest}>
        {children}
    </StyledHeadCell>
);

export const Row = ({ children, ...rest }: React.ComponentPropsWithoutRef<'tr'>) => (
    <StyledRow {...rest}>
        {children}
    </StyledRow>
);

interface TableColProps extends React.ComponentPropsWithoutRef<'td'> {
    align?: 'left' | 'center' | 'right';
}

export const Col = ({ children, ...rest }: TableColProps) => (
    <StyledCol {...rest}>
        {children}
    </StyledCol>
);

export const Body = ({ children, ...rest }: React.ComponentPropsWithoutRef<'tbody'>) => (
    <StyledBody {...rest}>
        {children}
    </StyledBody>
);

export const Head = ({ children, ...rest }: React.ComponentPropsWithoutRef<'thead'>) => (
    <StyledHead {...rest}>
        {children}
    </StyledHead>
);

interface TableProps extends React.ComponentPropsWithoutRef<'table'> {
    stretch?: boolean
}

export const Table = ({ children, ...rest }: TableProps) => (
    <StyledResponsiveContainer>
        <StyledTable {...rest}>
            {children}
        </StyledTable>
    </StyledResponsiveContainer>
);

Table.Body = Body;
Table.Row = Row;
Table.Col = Col;
Table.Head = Head;
Table.HeadCell = HeadCell;
